export default "__VITE_ASSET__D7xdWCr9__"